import { Item } from '../Card';
import { Body1, Caption } from '@xo-union/tk-ui-typography';
import React from 'react';

import { LivestreamItemsFragment } from '../../generated/graphql';
import { livestreamItemRoute } from '../../helpers/routes';
import { PageItemLink } from '../PageItemLink';
import { ItemProps } from './common';
import styles from './index.scss';

const Livestream: React.FC<ItemProps> = ({ page, item, className, dragProps, preview }) => {
  const livestream = item as LivestreamItemsFragment;

  return (
    <PageItemLink
      to={livestreamItemRoute(page.id, livestream.id, preview)}
      page={page}
      pageItem={item}
      data-testid={`livestream-item-${livestream.id}`}
    >
      <Item className={className} {...dragProps}>
        <div className={styles.container}>
          <Caption>Livestream</Caption>
          <Body1>{livestream.title}</Body1>
          <Caption>{livestream.buttonUrl}</Caption>
        </div>
      </Item>
    </PageItemLink>
  );
};

export default Livestream;
